import { Avatar, Dropdown, Menu } from 'antd';
import React from 'react';
import { useHistory } from 'react-router-dom';
import {  getUserAccessData, getUserDetails } from '../../utilities/sessionHelper';
import { getUserRole } from '../../utilities/CommonHelper';

const ProfileComponent = () => {
  const username = getUserDetails()?.username;
  const user_email = getUserDetails()?.email;
  const history = useHistory();
  

  const handleMenuClick = async (event: any)  => {
    switch (event.key) {
      case 'editRole':
        history.push('/requestAccess', { type: 'edit' });
        // <Redirect to={{ pathname: '/requestAccess' }} />;
        break;
      case 'pendingRequest':
        history.push('/rmPendingRequest');
        // <Redirect to={{ pathname: '/rmPendingRequest' }} />;
        break;
      case 'logout':
        localStorage.clear();
        document.cookie.split(";").forEach((c) => {
          document.cookie = c
            .replace(/^ +/, "")
            .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
        });
        window.location.href = `${process.env.REACT_APP_SSO_URL}indegenessoconnect/logout`;
        // <Redirect to={{ pathname: '/login' }} />;
        break;
      default:
        break;
    }
  };
  const role= getUserRole(getUserAccessData()?.roleAccessMap);
  const menu = (
    <Menu onClick={handleMenuClick}  style={{height:'110px',width:'200px'}}>
      <Menu.Item key="editRole" disabled={role && role!=="Admin"?false:true}>Edit Role</Menu.Item>
      <Menu.Item key="pendingRequest">Pending Request</Menu.Item>
      <Menu.Item key="logout">Logout</Menu.Item>
    </Menu>
  );
  const getInitials=(name:string)=>{
    let initials:any = name?.match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    return initials;
  }

  return (
    <div>
      <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
        <div className="user-profile">
        <Avatar style={{ backgroundColor: '#fde3cf', color: '#f56a00' }}>{getInitials(username)}</Avatar>
      <div className="user-info">
        <span className="user-name">{username}</span>
        <span className="user-designation">{user_email}</span>
        {getUserRole(getUserAccessData()?.roleAccessMap) !== null && 
        (<span className="user-designation">Role: {getUserRole(getUserAccessData()?.roleAccessMap)}</span>)}
      </div>
      </div>
      </Dropdown>
    </div>
  );
};

export default ProfileComponent;